export const UpdateConnectionString = "UpdateConnString";
export const SubmitCodeBlock = "SubmitCodeBlock";
